import classNames from 'classnames';
import { useRouter } from 'next/router';

/**
 * Internal dependencies
 */
import { getSlug } from "utils";
import Link from "components/link/link";

export const SidebarList = ({ item, current, sublinks, active, app }: any) => {
  const router = useRouter();
  const key = app ? 'apps' : 'themes';

  const hasTheme = (themes: any) => {
    return themes.data.find(({ attributes: theme }: any) => {
      return theme.slug_overwrite === router.query.theme || theme.slug === router.query.theme
    })
  }

  const hasActiveChild = (item: any) =>
    item.attributes.documentations.data.find(
      (doc: any) => doc.attributes.slug === current.attributes.slug
    );

  return (
    <div
      className={classNames("button-holder", { active: active })}
    >
      <Link
        href={`/help-center/documentation/${app ? 'app' : 'theme'}/${router.query.theme}/${getSlug(item.attributes.documentations.data[0]?.attributes)}`}
        className={classNames("button", {
          "is-active": current && hasActiveChild(item),
        })}
      >
        {item.attributes.Title}
      </Link>
      {sublinks && (
        <ul>
          {item.attributes.documentations.data.map((doc: any) => {
            if(!hasTheme(doc.attributes[key])) {
              return null;
            }

            return (
              <li key={doc.id}>
                <Link
                  href={`/help-center/documentation/${app ? 'app' : 'theme'}/${router.query.theme}/${getSlug(doc.attributes)}`}
                  className={classNames("button", {
                    "is-active":
                      doc.attributes.slug === current?.attributes.slug,
                  })}
                >
                  {doc.attributes.Title}
                </Link>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}
